import React from 'react'
import { Svg } from './Svg'

export function ChevronRight(props) {
    return (
        <Svg strokeWidth={1.5} {...props}>
            <path d="M8.25 4.5l7.5 7.5-7.5 7.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </Svg>
    )
}
